import { Layout } from 'antd';
import PropTypes from 'prop-types';
import LegalHeader from './components/LegalHeader';

const { Content } = Layout;

export const LegalTemplate = ({ children, legalLoggedVersion }) => {
  const classNames = ['legal-template'];
  if (legalLoggedVersion) {
    classNames.push('legal-logged-version');
  }

  return (
    <div className={classNames.join(' ')}>
      <LegalHeader legalLoggedVersion={legalLoggedVersion} />

      <Layout className="content">
        <Content>{children}</Content>
      </Layout>
    </div>
  );
};

LegalTemplate.defaultProps = {
  legalLoggedVersion: false
};

LegalTemplate.propTypes = {
  children: PropTypes.node.isRequired,
  legalLoggedVersion: PropTypes.bool
};
